import { extendObservable } from 'mobx'

import { getAllOffices } from '@atheneum/api'

class AtheneumOfficeStore {
  constructor () {
    extendObservable(this, {
      atheneumOffices: null,
      loading: null
    })
  }

  init () {
    return this.getAtheneumOffices()
  }

  getAtheneumOffices () {
    this.loading = true

    return getAllOffices()
      .then(res => {
        this.atheneumOffices = res
        this.loading = false
      })
      .catch(() => {
        this.loading = false
      })
  }
}

export default AtheneumOfficeStore
